import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

interface UseShipperNetworkGroupProps {
  groupId: number;
}

export function useShipperNetworkGroup(props: UseShipperNetworkGroupProps) {
  const { groupId } = props;
  const { role } = useRoleContext();

  const url = role?.type === "SHIPPER" ? `/network-groups/${groupId}` : null;

  const { data, loading, error, refetch } = useSwrFetch<NetworkGroup>({
    url,
    errorMessage: "Failed to fetch network group",
  });

  return {
    networkGroup: data ?? null,
    loadingNetworkGroup: loading,
    networkGroupError: error,
    refetchNetworkGroup: refetch,
    networkGroupFetchSuccess: data !== undefined,
  };
}
